import aws from 'services/aws';
const { API } = aws;

const getBrandByExternalId = /* GraphQL */ `
  query getBrand($id: String, $nextToken: String) {
    listBrands(filter: { externalId: { eq: $id } }, nextToken: $nextToken) {
      nextToken
      items {
        id
        email
        name
        salesTeam(limit: 100000) {
          items {
            email
            familyName
            givenName
            id
            image
            languages
            phone
            role
          }
        }
        visits(limit: 100000) {
          items {
            afternoonEnd
            afternoonStart
            date
            id
            morningEnd
            morningStart
            slotCapacity
            slotTime
            createdAt
            slots(limit: 100000) {
              items {
                id
                date
                end
                start
                slotCapacity
                occupants(limit: 100000) {
                  items {
                    id
                    company
                    email
                    familyName
                    givenName
                    language
                    nation
                    pavillion
                    phone
                    profile
                    reason
                    role
                    stand
                    status
                    brandName
                    brandSalesforceId
                    brandEmail
                    userSalesforceId
                    referent {
                      familyName
                      givenName
                      email
                      role
                      id
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const createVisitMutation = /* GraphQL */ `
  mutation createVisit(
    $input: CreateVisitInput!
    $condition: ModelVisitConditionInput
  ) {
    createVisit(input: $input, condition: $condition) {
      id
    }
  }
`;

const createSlotMutation = /* GraphQL */ `
  mutation createSlot(
    $input: CreateSlotInput!
    $condition: ModelSlotConditionInput
  ) {
    createSlot(input: $input, condition: $condition) {
      id
    }
  }
`;

const deleteVisitMutation = /* GraphQL */ `
  mutation deleteVisit(
    $input: DeleteVisitInput!
    $condition: ModelVisitConditionInput
  ) {
    deleteVisit(input: $input, condition: $condition) {
      id
    }
  }
`;

const deleteSlotMutation = /* GraphQL */ `
  mutation deleteSlot(
    $input: DeleteSlotInput!
    $condition: ModelSlotConditionInput
  ) {
    deleteSlot(input: $input, condition: $condition) {
      id
    }
  }
`;

const updateBookingRequestMutation = /* GraphQL */ `
  mutation updateBookingRequest(
    $input: UpdateBookingRequestInput!
    $condition: ModelBookingRequestConditionInput
  ) {
    updateBookingRequest(input: $input, condition: $condition) {
      id
    }
  }
`;

const deleteBookingRequestMutation = /* GraphQL */ `
  mutation deleteBookingRequest(
    $input: DeleteBookingRequestInput!
    $condition: ModelBookingRequestConditionInput
  ) {
    deleteBookingRequest(input: $input, condition: $condition) {
      id
    }
  }
`;

export const getBrand = ({ showLoader, hideLoader, id }) =>
  new Promise((resolve, reject) => {
    showLoader && showLoader?.();

    API.post(getBrandByExternalId, { id }, true)
      .then((response) => {
        resolve(response.data.listBrands?.items?.[0]);
      })
      .catch((e) => {
        console.error('get-brand', e);
        reject();
      })
      .finally(() => hideLoader && hideLoader?.());
  });

export const createVisit = ({ showLoader, hideLoader, input }) =>
  new Promise((resolve, reject) => {
    showLoader && showLoader?.();

    API.post(createVisitMutation, { input }, true)
      .then((response) => {
        resolve(response.data.createVisit);
      })
      .catch((e) => {
        console.error('create-visit', e);
        reject();
      })
      .finally(() => hideLoader && hideLoader?.());
  });

export const createSlot = ({ showLoader, hideLoader, input }) =>
  new Promise((resolve, reject) => {
    showLoader && showLoader?.();

    API.post(createSlotMutation, { input }, true)
      .then((response) => {
        resolve(response.data.createSlot);
      })
      .catch((e) => {
        console.error('create-slot', e);
        reject();
      })
      .finally(() => hideLoader && hideLoader?.());
  });

export const deleteVisit = ({ showLoader, hideLoader, input }) =>
  new Promise((resolve, reject) => {
    showLoader && showLoader?.();

    API.post(deleteVisitMutation, { input }, true)
      .then((response) => {
        resolve(response.data.deleteVisit);
      })
      .catch((e) => {
        console.error('delete-visit', e);
        reject();
      })
      .finally(() => hideLoader && hideLoader?.());
  });

export const deleteSlot = ({ showLoader, hideLoader, input }) =>
  new Promise((resolve, reject) => {
    showLoader && showLoader?.();

    API.post(deleteSlotMutation, { input }, true)
      .then((response) => {
        resolve(response.data.deleteSlot);
      })
      .catch((e) => {
        console.error('delete-slot', e);
        reject();
      })
      .finally(() => hideLoader && hideLoader?.());
  });

export const updateBookingRequest = ({ showLoader, hideLoader, input }) =>
  new Promise((resolve, reject) => {
    showLoader && showLoader?.();

    API.post(updateBookingRequestMutation, { input }, true)
      .then((response) => {
        resolve(response.data.updateBookingRequest);
      })
      .catch((e) => {
        console.error('update-booking-request', e);
        reject();
      })
      .finally(() => hideLoader && hideLoader?.());
  });

export const deleteBookingRequest = ({ showLoader, hideLoader, input }) =>
  new Promise((resolve, reject) => {
    showLoader && showLoader?.();

    API.post(deleteBookingRequestMutation, { input }, true)
      .then((response) => {
        resolve(response.data.deleteBookingRequest);
      })
      .catch((e) => {
        console.error('delete-booking-request', e);
        reject();
      })
      .finally(() => hideLoader && hideLoader?.());
  });
